/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable camelcase */
import { AxiosResponse } from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import { privateFetcher } from 'services';

interface ReturnRequestPayload {
  slug: string;
  comment: string;
  return_proofs: {
    file_name: string;
    url: string;
  }[];
  line_items: object[];
  shipment_pk: number;
}

export const postReturn = async (
  organization_id: number,
  params: ReturnRequestPayload,
): Promise<AxiosResponse> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/return-tickets/${organization_id}/create/`;
    const { data } = await privateFetcher.post(url, params);
    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response.data?.message, error);
    }

    throw error;
  }
};
